import { BaseComponentUpdatePlugin } from '../core/BasePlugin';
import { IComponentUpdate } from '../core/types';

interface ConsoleLoggerConfig {
  logInterval: number;
  minUpdateCount: number;
  logAllUpdates: boolean;
}

export class ConsoleLoggerPlugin extends BaseComponentUpdatePlugin {
  private config: ConsoleLoggerConfig;
  private intervalId?: number;

  constructor(config: Partial<ConsoleLoggerConfig> = {}) {
    super('console-logger', 'Component Update Console Logger');
    this.config = {
      logInterval: 10000,
      minUpdateCount: 2,
      logAllUpdates: true,
      ...config
    };

    if (this.config.logInterval > 0) {
      this.startLogging();
    }
  }

  onComponentUpdated(data: IComponentUpdate): void {
    if (this.config.logAllUpdates) {
      this.logUpdate(data);
    }
  }

  private logUpdate(data: IComponentUpdate): void {
    if (!this.config.logAllUpdates && data.updateCount < this.config.minUpdateCount) {
      return;
    }

    console.groupCollapsed(`🔄 Component Updated: ${data.componentName}`);
    console.table({
      updateCount: data.updateCount,
      duration: `${data.updateDuration?.toFixed(2)}ms`,
      changedProps: data.changedProps?.join(', '),
      changedData: data.changedData?.join(', ')
    });
    console.groupEnd();
  }

  private startLogging(): void {
    this.intervalId = window.setInterval(() => {
      // Will be implemented when we add plugin communication
    }, this.config.logInterval);
  }

  disable(): void {
    super.disable();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
